
// import EventBus from '../../../libs/EventBus'

export default {
    data () {
        return {
            preloadPercent: {},
            preloadError: false,
        }
    },
    created() {
        if (window.preload) {
            this.preloadPercent = window.preload.getProgress()
            this.preloadError = window.preload.hasError()
        }
    },
    mounted() {
        window.EventBus.$on('preload_change', (progress) => {
            console.log('preload_change', process)
            this.preloadPercent = progress
        })

        window.EventBus.$on('preload_error', (error) => {
            this.preloadError = error
        })
    },
}